// extracted by mini-css-extract-plugin
export default {"bigVideo":"zegoOne2One_bigVideo__uvBFD","smallVideo":"zegoOne2One_smallVideo__zu-hy"};